<template>
<div class="container fill-height">

    <qrcode-stream id="frameCamera" :camera="camera" :track="paintOutline" @decode="onDecode" @init="onInit">
      <div v-if="validationSuccess" class="validation-success">
        This is a URL
      </div>

      <div v-if="validationFailure" class="validation-failure">
        This is NOT a URL!
      </div>

      <div v-if="validationPending" class="validation-pending">
        Long validation in progress...
      </div>
    </qrcode-stream>

</div>
</template>

<script>
import {QrcodeStream} from 'vue-qrcode-reader'

export default {
    name: 'MyTicketScan',
    components: {
        QrcodeStream
    },

    data () {
        return {
        isValid: undefined,
        camera: 'auto',
        result: null,
        }
    },

    computed: {
        validationPending () {
        return this.isValid === undefined
            && this.camera === 'off'
        },

        validationSuccess () {
        return this.isValid === true
        },

        validationFailure () {
        return this.isValid === false
        }
    },

    methods: {

        paintOutline (detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints

                ctx.strokeStyle = "red";

                ctx.beginPath();
                ctx.moveTo(firstPoint.x, firstPoint.y);
                for (const { x, y } of otherPoints) {
                ctx.lineTo(x, y);
                }
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                ctx.stroke();
            }
        },

        onInit (promise) {
        promise
            .catch(console.error)
            .then(this.resetValidationState)
        },

        resetValidationState () {
        this.isValid = undefined
        },

        async onDecode (content) {
        this.result = content
        this.turnCameraOff()

        // pretend it's taking really long
        await this.timeout(3000)
        this.isValid = content.startsWith('http')

        // some more delay, so users have time to read the message
        await this.timeout(2000)

        this.turnCameraOn()
        },

        turnCameraOn () {
        this.camera = 'auto'
        },

        turnCameraOff () {
        this.camera = 'off'
        },

        timeout (ms) {
        return new Promise(resolve => {
            window.setTimeout(resolve, ms)
        })
        }
  }

}
</script>

<style>

#frameCamera{
    height: 100%;
}

</style>